
import React, { useState } from 'react'
import icons from '../../../../../Data/icons'

const TaskList = ({classes ,row ,lists, setLists ,removeRow}) => {

    const Trash = icons.trash
    const Abc = icons.abc  
    const prevLists = lists[row.id] || { name: "", description: "", attachements:null };

    const handleNameChange = (e) => {
      const { value } = e.target;
      setLists({
        ...lists,
        [row.id]: { ...prevLists, name: value },
      });
    };
  
    const handleDesChange = (e) => {
      const { value } = e.target;
      setLists(({
        ...lists,
        [row.id]: { ...prevLists, description: value },
      }));
    };
  
    const handleAttachments = (e) => {
      const file = e.target.files[0];
    
      if (file) {
        const newAttachment = { name: file.name, file };
        setLists(({
          ...lists,
          [row.id]: {
            ...prevLists,
            attachements: [...(prevLists?.attachements || []), newAttachment],
          },
        }));
      }
    };

  return (
   
    <div>
    {/* <div className={classes.iconInput}>
      <Abc />
    </div> */}
    <div className='form-group'>
    <input type="text" className="form-control" placeholder="ادخل الاسم" onChange={handleNameChange}/>
  
    </div>
  
 <div className='form-group'>
 <textarea type="textarea"  className="form-control" placeholder="ادخل الوصف" onChange={handleDesChange} />
 </div>
  <div className='form-group'>
 <input type="file"  className="form-control" onChange={handleAttachments}/>
</div>
  <button className={classes.removeBtn} onClick={()=>removeRow(row.id)}><Trash/></button>
    </div>
  )
}

export default TaskList